import { nanoid } from 'nanoid';
import React from 'react';

export interface TextProps {
  node: {
    fieldDescription?: string;
  };
}

export const TextParagraph = ({ node }: TextProps) => (
  <div
    key={nanoid()}
    className="blog-portfolio-paragraphs"
    dangerouslySetInnerHTML={{ __html: node.fieldDescription || '' }}
  />
);
